import { render, staticRenderFns } from "./register.vue?vue&type=template&id=128cf461&"
import script from "./register.ts?vue&type=script&lang=js&"
export * from "./register.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports